export const GetFundsActionTypes = {
  GET_FUNDS_LOADING: "GET_FUNDS_LOADING",
  GET_FUNDS_ERROR: "GET_FUNDS_ERROR",
  GET_FUNDS_SUCCESS: "GET_FUNDS_SUCCESS",
};
